// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DialogUpdateProfileUser__Component .modal-card .modal-card-head .modal-card-title[data-v-77b348a3] {\n  font-size: 1.5rem;\n}\n.DialogUpdateProfileUser__Component .modal-card .modal-card-body[data-v-77b348a3] {\n  padding: 1rem;\n}\n.DialogUpdateProfileUser__Component .modal-card-foot[data-v-77b348a3] {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 1rem;\n  border-top: 1px solid #e0e0e0;\n}\n", ""]);
// Exports
module.exports = exports;
